<template>
    <el-dialog :visible.sync="visible" title="详情" :close-on-click-modal="false" :close-on-press-escape="false"
        :append-to-body="appendToBody" :destroy-on-close="true">
        <template v-if="dataForm.taskType == '1'">
            <el-descriptions title="基本信息" direction="vertical" :column="4" border>
                <el-descriptions-item label="姓名">{{ detailData.xm }}</el-descriptions-item>
                <el-descriptions-item label="性别">{{ detailData.sex }}</el-descriptions-item>
                <el-descriptions-item label="联系方式">{{ detailData.mobile }}</el-descriptions-item>
                <el-descriptions-item label="出生年月">{{ detailData.birthday }}</el-descriptions-item>
                <el-descriptions-item label="残疾部位" :span="2">{{ detailData.cjInfo }}</el-descriptions-item>
                <el-descriptions-item label="居住地">{{ detailData.liveAddress }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="照片信息" direction="vertical" :column="4" border>
                <el-descriptions-item label="任务留痕照片">
                    <el-image v-if="detailData.photoUrl" style="width: 100px; height: 100px" :src="detailData.photoUrl" fit="contain"
                        :preview-src-list="detailData.photoUrl"></el-image>
                </el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="就业信息" direction="vertical" :column="4" border>
                <el-descriptions-item label="是否已就业">{{ detailData.working }}</el-descriptions-item>
                <el-descriptions-item label="是否有就业意向">{{ detailData.hasWorkIntent }}</el-descriptions-item>
                <el-descriptions-item label="就业意向类别">{{ detailData.workIntentType }}</el-descriptions-item>
                <el-descriptions-item label="求职意向">{{ detailData.workIntent }}</el-descriptions-item>
                <el-descriptions-item label="是否有能力就业" :span="2">{{ detailData.workCapable }}</el-descriptions-item>
                <el-descriptions-item label="是否需要残联培训">{{ detailData.requireTraining }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="教育信息" direction="vertical" :column="4" border>
                <el-descriptions-item label="毕业院校">{{ detailData.school }}</el-descriptions-item>
                <el-descriptions-item label="学历">{{ detailData.educationBackground }}</el-descriptions-item>
                <el-descriptions-item label="专业">{{ detailData.major }}</el-descriptions-item>
            </el-descriptions>
        </template>
        <template v-if="dataForm.taskType == '2'">
            <el-descriptions title="基本信息" direction="vertical" :column="4" border>
                <el-descriptions-item label="姓名">{{ detailData.xm }}</el-descriptions-item>
                <el-descriptions-item label="性别">{{ detailData.sex }}</el-descriptions-item>
                <el-descriptions-item label="联系方式">{{ detailData.mobile }}</el-descriptions-item>
                <el-descriptions-item label="出生年月">{{ detailData.birthday }}</el-descriptions-item>
                <el-descriptions-item label="残疾部位" :span="2">{{ detailData.cjInfo }}</el-descriptions-item>
                <el-descriptions-item label="居住地">{{ detailData.liveAddress }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="照片信息" direction="vertical" :column="4" border>
                <el-descriptions-item label="任务留痕照片">
                    <el-image v-if="detailData.photoUrl" style="width: 100px; height: 100px" :src="detailData.photoUrl" fit="contain"
                        :preview-src-list="detailData.photoUrl"></el-image>
                </el-descriptions-item>
            </el-descriptions>
        </template>
        <template v-if="dataForm.taskType == '3'">
            <el-descriptions title="基本信息" direction="vertical" :column="4" border>
                <el-descriptions-item label="残协名称">{{ detailData.updater }}</el-descriptions-item>
                <el-descriptions-item label="专职委员">{{ detailData.handicappedXm }}</el-descriptions-item>
                <el-descriptions-item label="联系方式">{{ detailData.handicappedMobile }}</el-descriptions-item>
                <el-descriptions-item label="村名称">{{ detailData.cun }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="照片信息" direction="vertical" :column="4" border>
                <el-descriptions-item label="任务留痕照片">
                    <el-image v-if="detailData.photoUrl" style="width: 100px; height: 100px" :src="detailData.photoUrl" fit="contain"
                        :preview-src-list="detailData.photoUrl"></el-image>
                </el-descriptions-item>
            </el-descriptions>
        </template>
        <template slot="footer">
            <el-button type="primary" @click="dataFormSubmitHandle()">确定</el-button>
        </template>
    </el-dialog>
</template>

<script>
export default {
    props: {
        appendToBody: {
            type: Boolean,
            require: false,
            default: false
        },
    },
    data() {
        return {
            visible: false,
            dataForm: {
                id: "",
                taskType: "",
            },
            detailData: {},
            detailUrl: "",
            fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
            url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
        };
    },
    computed: {},
    methods: {
        init(id, taskType) {
            this.detailData={}
            this.dataForm = { id, taskType };
            this.visible = true;
            if (taskType == "1") {
                this.detailUrl = this.$baseURL+"/api/task/result/extension";
            }
            if (taskType == "2") {
                this.detailUrl = this.$baseURL+"/api/task/result/zfrh";
            }
            if (taskType == "3") {
                this.detailUrl = this.$baseURL+"/api/task/result/wthd";
            }
            this.getInfo();
        },
        // 获取信息
        getInfo() {
            axios
                .get(this.detailUrl, { params: { id: this.dataForm.id } })
                .then(({ data: res }) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg);
                    }
                    this.detailData = res.data;
                })
                .catch(() => { });
        },
        dataFormSubmitHandle() {
            this.visible = false
            this.dataForm={}
            this.dataForm={}    
        }
    },
};
</script>
